import React, { Fragment, useEffect, useState } from "react";
import Header from "../../Components/Layout/Header";
import {
  Backdrop,
  Box,
  Container,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import styles from "./Cart.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";
import Parse from "../../API/ParseServer";
import backBoardPic from "../Assets/frames/BackingBoard.webp";

import { loadStripe } from "@stripe/stripe-js";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import load from "../../Assets/logo/FaamGallery-Page-Loader1-ezgif.com-gif-to-mp4-converter.mp4";
import ArtworkFrameItem from "../../Components/CartItems/ArtworkFrameItem";
import ArtworkItem from "../../Components/CartItems/ArtworkItem";
import FrameItem from "../../Components/CartItems/FrameItem";
import UserArtworkItem from "../../Components/CartItems/UserArtworkItem";
import UserArtworkFrameItem from "../../Components/CartItems/UserArtworkFrameItem";
import ClearIcon from "@mui/icons-material/Clear";
import Footer from "../../Components/Layout/Footer";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useCart } from "../../Context/CartContext";
const stripePromise = loadStripe(
  "pk_live_51QkZ0xJPnfkeIE7eT6okLk4a4sAtBAcJIA5nXZaTMyHhmVWTj8yriZ2879VgzSswZ8VQ5VX55AlvbRplLRO7SPmP00ygwu2jDl",
);

const Cart = () => {
  const [basket, setBasket] = useState<any>();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [pricing, setPricing] = useState<any>();
  const [artworkQuantities, setArtworkQuantities] = useState();
  const [discount, setDiscount] = useState<any>();
  const { setTotalQuantity } = useCart();
  useEffect(() => {
    const fetchBasket = async () => {
      localStorage.removeItem("framingMode");
      localStorage.removeItem("inputHeight");
      localStorage.removeItem("inputWidth");
      localStorage.removeItem("uploadImageId");
      localStorage.removeItem("artworkTitle");
      localStorage.removeItem("editItemId");
      setLoading(true);

      const user = Parse.User.current();
      if (user || localStorage.getItem("guestId")) {
        try {
          const basket = await Parse.Cloud.run("getBasket", {
            user: user ? user.id : localStorage.getItem("guestId"),
          });
          if (basket.get("discountId")) {
            const Discount = Parse.Object.extend("Discount");
            const discountQuery = new Parse.Query(Discount).equalTo(
              "objectId",
              basket.get("discountId"),
            );
            const discount = await discountQuery.first();
            setDiscount(discount);
          } else setDiscount(null);
          if (basket.get("status") !== "completed") {
            setBasket(basket);
            setSubtotal(0);
            setTotal(-(basket.get("discountAmount") || 0));
            basket.get("items").forEach((item: any) => {
              setSubtotal((current) => current + item.quantity);
              setTotal((current) => current + item.price * item.quantity);
            });
            const artworkQuantities: any = {};
            basket
              .get("items")
              .filter(
                (item: any) =>
                  item.type === "ArtworkFrame" || item.type === "Artwork",
              )
              .forEach((item: any) => {
                const artworkId = item.artwork.id;
                artworkQuantities[artworkId] =
                  (artworkQuantities[artworkId] || 0) + item.quantity;
              });
            console.log(artworkQuantities);
            setArtworkQuantities(artworkQuantities);
            let totalQuantity = 0;
            basket.get("items").forEach((item: any) => {
              totalQuantity += item.quantity;
            });
            setTotalQuantity(totalQuantity);
            localStorage.setItem("totalQuantity", String(totalQuantity));
          }
        } catch (error) {
          console.error("Error fetching basket:", error);
        } finally {
          setLoading(false);
        }
      }
      const pricingQuery = new Parse.Query("Pricing");
      try {
        const results = await pricingQuery.find();
        setPricing(results[0]);
        console.log(results[0]);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    localStorage.removeItem("framingMode");
    localStorage.removeItem("inputHeight");
    localStorage.removeItem("inputWidth");
    localStorage.removeItem("uploadImageId");
    localStorage.removeItem("artworkTitle");
    localStorage.removeItem("editItemId");

    fetchBasket();
  }, []);

  const updateTotalHandler = async () => {
    const user = Parse.User.current();
    if (user || localStorage.getItem("guestId")) {
      try {
        const newBasket = await Parse.Cloud.run("getBasket", {
          user: user ? user.id : localStorage.getItem("guestId"),
        });
        setBasket(newBasket);
        if (newBasket.get("discountId")) {
          const Discount = Parse.Object.extend("Discount");
          const discountQuery = new Parse.Query(Discount).equalTo(
            "objectId",
            newBasket.get("discountId"),
          );
          const discount = await discountQuery.first();
          setDiscount(discount);
        } else setDiscount(null);
        if (newBasket.get("status") !== "completed") {
          setSubtotal(0);
          setTotal(-(newBasket.get("discountAmount") || 0));
          newBasket.get("items").forEach((item: any) => {
            setSubtotal((current) => current + item.quantity);
            setTotal((current) => current + item.price * item.quantity);
          });
        }
        const artworkQuantities: any = {};
        newBasket
          .get("items")
          .filter(
            (item: any) =>
              item.type === "ArtworkFrame" || item.type === "Artwork",
          )
          .forEach((item: any) => {
            const artworkId = item.artwork.id;
            artworkQuantities[artworkId] =
              (artworkQuantities[artworkId] || 0) + item.quantity;
          });
        console.log(artworkQuantities);
        setArtworkQuantities(artworkQuantities);
        let totalQuantity = 0;
        basket.get("items").forEach((item: any) => {
          totalQuantity += item.quantity;
        });
        setTotalQuantity(totalQuantity);
        localStorage.setItem("totalQuantity", String(totalQuantity));
      } catch (error) {
        console.error("Error fetching basket:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  const [modal, setModal] = React.useState("");
  const handleClose = () => {
    setModal("");
  };
  const handleOpen = (error: string) => {
    setModal(error);
  };
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [checkoutError, setCheckoutError] = useState(null);
  const [unavailables, setUnavailables] = useState();
  const [unavailableIds, setUnavailableIds] = useState<any>();
  const [discountCode, setDiscountCode] = useState();
  const [discountMessage, setDiscountMessage] = useState("");
  const [discountResolver, setDiscountResolver] = useState<any>(null);
  const [discountLoading, setDiscountLoading] = useState(false);
  const discountCodeChangeHandler = (event: any) => {
    setDiscountCode(event.target.value);
  };
  const discountHandler = async () => {
    if (discountCode) {
      try {
        setDiscountLoading(true);
        const discount = await Parse.Cloud.run("applyDiscountCode", {
          code: discountCode,
          basketId: basket.id,
        });
        // console.log(discount);
        setDiscountMessage("");
        updateTotalHandler();
      } catch (error: any) {
        console.log(error);
        setDiscountMessage(error.message);
      } finally {
        updateTotalHandler();
        setDiscountLoading(false);
      }
    } else {
      setDiscountMessage("You should enter your discount code!");
    }
  };
  const removeDiscountHandler = async () => {
    try {
      const basketId = basket.id;
      const response = await Parse.Cloud.run("removeDiscount", {
        basketId,
      });
      if (response) window.location.reload();
      updateTotalHandler();
      // Optionally: Refresh basket state here
    } catch (err: any) {
      console.error("Failed to remove discount:", err.message || err);
    } finally {
      updateTotalHandler();
    }
  };
  const loseDiscountHandler = (itemId: any, del: any) => {
    const item = basket
      .get("items")
      .filter((item: any) => item.itemId === itemId)[0];

    if (
      basket.get("discountAmount") &&
      total +
        basket.get("discountAmount") -
        (del ? item.price * item.quantity : item.price) <
        discount.get("minimumSpend")
    )
      return new Promise((resolve) => {
        setModal("loseDiscount");
        setDiscountResolver(() => resolve);
      });
    else return true;
  };
  const loseDiscountChoiceHandler = async (value: any) => {
    if (discountResolver) {
      discountResolver(value); // resolve the promise
      setModal("");
      setDiscountResolver(null);
      if (value) {
        try {
          const basketId = basket.id;
          const response = await Parse.Cloud.run("removeDiscount", {
            basketId,
          });
          if (response) window.location.reload();
          // Optionally: Refresh basket state here
        } catch (err: any) {
          console.error("Failed to remove discount:", err.message || err);
        } finally {
          updateTotalHandler();
        }
      }
    }
  };
  const handleCheckout = async () => {
    const user = Parse.User.current();
    if (!user) handleOpen("login");
    else {
      setCheckoutLoading(true);
      setCheckoutError(null);

      try {
        // 1. Create Checkout Session
        const { id: sessionId } = await Parse.Cloud.run(
          "createCheckoutSession",
          {
            basketId: basket.id,
          },
        );

        // 2. Redirect to Stripe
        const stripe = await stripePromise;
        if (stripe) {
          const { error } = await stripe.redirectToCheckout({ sessionId });

          if (error) throw error;
        }
      } catch (err: any) {
        console.log(err.message.slice(10));
        // console.log(typeof JSON.parse(err.message));
        if (err.message.search("unavilable") !== -1) {
          const artworkIds = Object.keys(JSON.parse(err.message.slice(10)));
          setUnavailables(JSON.parse(err.message.slice(10)));
          setUnavailableIds(artworkIds);
          setModal("unavailable");
        }
        setCheckoutLoading(false);
      }
    }
  };
  function addCommas(num: number | String) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <Fragment>
      <Backdrop
        sx={(theme) => ({
          color: "#fff",
          zIndex: theme.zIndex.drawer + 1,
        })}
        open={modal === "" ? false : true}
        // onClick={handleClose}
      >
        {" "}
        <Box
          sx={{
            backgroundColor: "white",
            width: { xs: "95vw", lg: "30rem" },
            // height: { xs: "30rem", lg: "auto" },
            display: "flex",
            justifyContent: "space-between",
            // alignItems: "center",
            color: "black",
            py: { md: 5, xs: 2 },
            px: { md: 7, xs: 4 },
            position: "relative",
            flexDirection: "column",
            borderRadius: "20px",
          }}
        >
          <button
            style={{
              position: "absolute",
              right: "1.5rem",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
              top: "1.5rem",
            }}
            onClick={handleClose}
          >
            <ClearIcon />
          </button>
          {modal === "login" ? (
            <Fragment>
              {" "}
              <Typography variant="h5" sx={{ textAlign: "center" }}>
                You need login to your account before checkout
              </Typography>
              <Link to={"/login"} style={{ textAlign: "center" }}>
                <Typography variant="h5" sx={{ color: "#863a1d", mt: 5 }}>
                  login
                </Typography>
              </Link>
            </Fragment>
          ) : modal === "unavailable" ? (
            <Fragment>
              <Typography variant="h6" sx={{ mb: 4 }}>
                Oops! Some items in your Cart are no longer available in the
                desired quantity. <br />
                Please adjust the items that include the following Artworks
              </Typography>

              {unavailables &&
                unavailableIds.map((item: any) => (
                  <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                    Artwork "{unavailables[item][0]}" is now limited to{" "}
                    {unavailables[item][1]} piece(s)
                  </Typography>
                ))}
            </Fragment>
          ) : (
            modal === "loseDiscount" && (
              <Fragment>
                <Typography variant="h5" sx={{ textAlign: "center" }}>
                  You’ll lose your applied discount. Don’t miss out on £
                  {basket.get("discountAmount").toFixed(2)} saving!
                </Typography>
                <Box
                  sx={{
                    margin: "1rem auto",
                    width: "70%",
                    display: "flex",
                    justifyContent: "center",
                    gap: 3,
                  }}
                >
                  <button
                    className={styles["proceed-button"]}
                    onClick={() => loseDiscountChoiceHandler(true)}
                  >
                    Procced
                  </button>
                  <button
                    className={styles["proceed-button"]}
                    onClick={() => loseDiscountChoiceHandler(false)}
                  >
                    Cancel
                  </button>
                </Box>
              </Fragment>
            )
          )}
        </Box>
      </Backdrop>
      <Container sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" sx={{ textAlign: "center" }}>
          Shopping Cart
        </Typography>
        {loading ? (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              pt: 10,
            }}
          >
            <span className={styles.loader}></span>
          </Box>
        ) : basket && basket.get("items").length ? (
          <Grid container>
            <Grid item container md={8} xs={12}>
              {basket &&
                pricing &&
                basket
                  .get("items")
                  .toSorted((a: any, b: any) => {
                    if (a.itemId < b.itemId) return -1;
                    if (a.itemId > b.itemId) return 1;
                    return 0;
                  })
                  .map((item: any) => {
                    if (item.type === "Artwork") {
                      return (
                        <ArtworkItem
                          item={item}
                          pricing={pricing}
                          updateTotal={updateTotalHandler}
                          artworkQuantities={artworkQuantities}
                          loseDiscount={loseDiscountHandler}
                        />
                      );
                    }
                    if (item.type === "Frame") {
                      return (
                        <FrameItem
                          item={item}
                          pricing={pricing}
                          updateTotal={updateTotalHandler}
                          loseDiscount={loseDiscountHandler}
                        />
                      );
                    }
                    if (item.type === "UserArtwork") {
                      return (
                        <UserArtworkItem
                          item={item}
                          pricing={pricing}
                          updateTotal={updateTotalHandler}
                          loseDiscount={loseDiscountHandler}
                        />
                      );
                    }
                    if (item.type === "ArtworkFrame") {
                      return (
                        <ArtworkFrameItem
                          item={item}
                          pricing={pricing}
                          updateTotal={updateTotalHandler}
                          artworkQuantities={artworkQuantities}
                          loseDiscount={loseDiscountHandler}
                        />
                      );
                    }
                    if (item.type === "UserArtworkFrame") {
                      return (
                        <UserArtworkFrameItem
                          item={item}
                          pricing={pricing}
                          updateTotal={updateTotalHandler}
                          loseDiscount={loseDiscountHandler}
                        />
                      );
                    }
                  })}
            </Grid>
            {basket &&
              basket.get("items") &&
              basket.get("totalAmount") &&
              pricing && (
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    borderLeft: { md: "2px solid #f3f4f5" },
                    pl: { md: 5 },
                    mt: { xs: 4, md: 0 },
                  }}
                >
                  {discount ? (
                    <Box
                      // spacing={2}
                      sx={{
                        borderBottom: "2px solid #f3f4f5",
                        pb: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Box sx={{ display: "flex" }}>
                          <Typography>
                            {" "}
                            <Typography
                              sx={{ display: "inline", fontWeight: "bold" }}
                            >
                              {discount.get("title")}
                            </Typography>{" "}
                            has been applied
                          </Typography>
                        </Box>{" "}
                        <Box sx={{ display: "flex" }}>
                          <Typography variant="caption">
                            <Typography
                              sx={{ display: "inline", fontWeight: "bold" }}
                              variant="caption"
                            >
                              {discount.get("code")}{" "}
                            </Typography>{" "}
                            applies {discount.get("percent")}% discount on
                            total 
                            {discount.get("limit_gbp") > 0 &&
                              `(up to £${discount.get("limit_gbp")} off)`}
                          </Typography>
                        </Box>
                      </Box>
                      <button
                        onClick={removeDiscountHandler}
                        style={{
                          background: "none",
                          border: "none",
                          outline: "none",
                          cursor: "pointer",
                          color: "red",
                        }}
                      >
                        <DeleteOutlineIcon />
                      </button>
                    </Box>
                  ) : (
                    <Grid
                      container
                      // spacing={2}
                      sx={{
                        borderBottom: "2px solid #f3f4f5",
                        pb: 1,
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Grid item xs={8.8}>
                        <input
                          type="text"
                          className={styles.input}
                          placeholder="Discount code"
                          onChange={discountCodeChangeHandler}
                        />
                      </Grid>
                      <Grid item xs={2.8}>
                        <button
                          className={styles["proceed-button"]}
                          onClick={discountHandler}
                        >
                          {discountLoading ? (
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                // pt: 10,
                              }}
                            >
                              <span className={styles["mini-loader"]}></span>
                            </Box>
                          ) : (
                            "Apply"
                          )}
                        </button>
                      </Grid>{" "}
                      {discountMessage && (
                        <Typography sx={{ mt: 1 }}>
                          {discountMessage}
                        </Typography>
                      )}
                    </Grid>
                  )}

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <Typography variant="subtitle2">
                      Subtotal{" "}
                      <Typography
                        variant="caption"
                        sx={{ display: "inline", color: "gray" }}
                      >
                        ({subtotal} items)
                      </Typography>
                    </Typography>
                    <Typography>
                      £
                      {addCommas(
                        (total + (basket.get("discountAmount") || 0)).toFixed(
                          2,
                        ),
                      )}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="subtitle2">
                      Shipping{" "}
                      <Typography
                        variant="caption"
                        sx={{ display: "inline", color: "gray" }}
                      >
                        (finalaised at checkout)
                      </Typography>
                    </Typography>
                    <Typography>
                      {pricing &&
                        (total >= pricing.get("freeDelivery_pound")
                          ? "Free"
                          : subtotal <= 5
                            ? `£${pricing.get("deliveryPrice")}`
                            : `£${
                                pricing.get("deliveryPrice") +
                                pricing.get("deliveryAdditionalPrice")
                              }`)}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="subtitle2">
                      Order Completion Time{" "}
                      <Typography
                        variant="caption"
                        sx={{ display: "inline", color: "gray" }}
                      >
                        (if you order today)
                      </Typography>
                    </Typography>
                    {/* <Typography>£265</Typography> */}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ color: "gray" }}>
                      Production Time
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: "gray" }}>
                      +{" "}
                      {pricing &&
                        Math.max(
                          ...basket
                            .get("items")
                            .map((item: any) => Number(item.arrival)),
                        ) - Number(pricing.get("delivery_day"))}{" "}
                      Working day
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      my: -1,
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ color: "gray" }}>
                      Delivery Time
                    </Typography>
                    <Typography variant="subtitle2" sx={{ color: "gray" }}>
                      + {pricing && Number(pricing.get("delivery_day"))} Working
                      day
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{ color: "gray", fontWeight: "1000" }}
                    >
                      Arrival to you in about
                    </Typography>
                    <Typography variant="subtitle2" sx={{ fontWeight: "1000" }}>
                      {Math.max(
                        ...basket
                          .get("items")
                          .map((item: any) => Number(item.arrival)),
                      )}{" "}
                      Working day
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="h4" component="h2">
                      Total
                      <Typography
                        variant="caption"
                        sx={{
                          color: "gray",
                          display: "block",
                          fontWeight: "1000",
                        }}
                      >
                        including £
                        {addCommas(
                          (
                            (total > pricing.get("freeDelivery_pound")
                              ? total
                              : subtotal <= 5
                                ? total + pricing.get("deliveryPrice")
                                : total +
                                  pricing.get("deliveryPrice") +
                                  pricing.get("deliveryAdditionalPrice")) / 6
                          ).toFixed(2),
                        )}{" "}
                        VAT
                      </Typography>
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: "1000",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                      component="h2"
                    >
                      £
                      {addCommas(
                        (total > pricing.get("freeDelivery_pound")
                          ? total
                          : subtotal <= 5
                            ? total + pricing.get("deliveryPrice")
                            : total +
                              pricing.get("deliveryPrice") +
                              pricing.get("deliveryAdditionalPrice")
                        ).toFixed(2),
                      )}
                      {basket.get("discountAmount") && (
                        <Typography variant="caption" sx={{}}>
                          You saved £
                          {basket.get("discountAmount").toFixed(2) || 0}
                        </Typography>
                      )}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      color: "#595959",
                      fontWeight: "1000",
                      mt: 1,
                      backgroundColor: "#f9e9e3",
                      p: "10px 15px",
                      borderRadius: "10px",
                      mb: 3,
                    }}
                  >
                    {basket.get("totalAmount") <
                    pricing.get("freeDelivery_pound") ? (
                      <Fragment>
                        Add £
                        {(
                          pricing.get("freeDelivery_pound") -
                          basket.get("totalAmount")
                        ).toFixed(2)}{" "}
                        more to get{" "}
                        <Typography sx={{ display: "inline", color: "black" }}>
                          Free Shipping
                        </Typography>
                      </Fragment>
                    ) : (
                      <Typography>
                        Congratulation, this order qualifies for Free Delivery!
                      </Typography>
                    )}
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      py: 3,
                      borderTop: "2px solid #f3f4f5",
                    }}
                  >
                    <button
                      className={styles["proceed-button"]}
                      onClick={handleCheckout}
                    >
                      Checkout
                    </button>
                    <Link to={"/shop"}>
                      <button className={styles["custome-button"]}>
                        Keep Shopping
                      </button>
                    </Link>
                  </Box>
                  <Typography>
                    After checkout, we'll collect your information and provide
                    mailing options.
                  </Typography>
                </Grid>
              )}
          </Grid>
        ) : (
          <Typography variant="h5" sx={{ textAlign: "center", mt: 10, mb: 20 }}>
            Your Cart Awaits Beautiful Selections
          </Typography>
        )}
      </Container>
    </Fragment>
  );
};

export default Cart;
// Congratulation, this order qualifies for Free Delivery!
// incl. £5.59 VAT
